import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import SideBar from './components/SideBar';
import AssistantMascot from './components/AssistantMascot';
import ToolFrame from './pages/ToolFrame';
import Management from './pages/Management';
import Commercial from './pages/Commercial';
import Teams from './pages/Teams';
import GlobalSearch from './components/GlobalSearch';
import AlertCenter from './pages/AlertCenter';
import Clients from './pages/Clients';
import config from './config';
import './styles/global.css';
import './styles/polish.css';

function App() {
  const [user, setUser] = useState(() => {
    if (!localStorage.getItem(config.tokenKey)) return null;
    const saved = localStorage.getItem(config.userKey);
    if (!saved) return null;
    try {
      return JSON.parse(saved);
    } catch {
      localStorage.removeItem(config.userKey);
      localStorage.removeItem(config.tokenKey);
      return null;
    }
  });
  const [toolRequest, setToolRequest] = useState(null);

  // Injection des couleurs client via CSS variables
  useEffect(() => {
    document.documentElement.style.setProperty('--primary', config.primaryColor);
    document.documentElement.style.setProperty('--accent',  config.accentColor);
    document.title = config.clientName + ' — CRM';
  }, []);

  useEffect(() => {
    const allowedOrigins = new Set(config.apps.map((app) => {
      try { return new URL(app.url).origin; } catch { return null; }
    }).filter(Boolean));
    const handleNavigation = (event) => {
      const message = event.data;
      if (!message || message.type !== 'hrtp:navigate') return;
      if (event.origin !== window.location.origin && !allowedOrigins.has(event.origin)) return;
      if (!config.apps.some((app) => app.key === message.app)) return;
      setToolRequest({ app: message.app, sourceProject: message.sourceProject || '', nonce: Date.now() });
      window.history.pushState({}, '', `/${message.app}`);
      window.dispatchEvent(new PopStateEvent('popstate'));
    };
    window.addEventListener('message', handleNavigation);
    return () => window.removeEventListener('message', handleNavigation);
  }, []);

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Login setUser={setUser} />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <div className="admin-page">
        <SideBar user={user} setUser={setUser} />

        <div className="crm-workspace">
          <GlobalSearch setToolRequest={setToolRequest} />
          <div className="iframe-wrapper">
            <Routes>
            {config.apps.map(app => (
              <Route
                key={app.key}
                path={`/${app.key}`}
                element={app.adminOnly && String(user.role).toLowerCase() !== 'admin'
                  ? <Navigate to={config.defaultRoute} replace />
                  : app.component === 'commercial'
                  ? <Commercial />
                    : app.component === 'clients'
                    ? <Clients />
                    : app.component === 'alerts'
                    ? <AlertCenter setToolRequest={setToolRequest} />
                    : app.component === 'teams'
                    ? <Teams />
                    : app.native
                    ? <Management key={app.key} module={app.module} />
                    : <ToolFrame app={{ ...app, request: toolRequest?.app === app.key ? toolRequest : null }} />}
              />
            ))}
            <Route path="*" element={<Navigate to={config.defaultRoute} />} />
            </Routes>
          </div>
        </div>
        <AssistantMascot user={user} />
      </div>
    </Router>
  );
}

export default App;
